export const currencies: Array<{
  Code: string;
  Name: string;
  Id: number;
}> = [
  {
    Code: "DKK",
    Name: "Danish Krone",
    Id: 176,
  },
  {
    Code: "EUR",
    Name: "Euro",
    Id: 108,
  },
  {
    Code: "NOK",
    Name: "Norwegian Krone",
    Id: 52,
  },
  {
    Code: "SEK",
    Name: "Swedish Krona",
    Id: 25,
  },
  {
    Code: "AED",
    Name: "UAE Dirham",
    Id: 67,
  },
  {
    Code: "AFN",
    Name: "Afghani",
    Id: 20,
  },
  {
    Code: "ALL",
    Name: "Lek",
    Id: 57,
  },
  {
    Code: "AMD",
    Name: "Armenian Dram",
    Id: 21,
  },
  {
    Code: "ANG",
    Name: "Netherlands Antillea",
    Id: 6,
  },
  {
    Code: "AOA",
    Name: "Kwanza",
    Id: 101,
  },
  {
    Code: "ARS",
    Name: "Argentine Peso",
    Id: 116,
  },
  {
    Code: "AUD",
    Name: "Australian Dollar",
    Id: 144,
  },
  {
    Code: "AWG",
    Name: "Aruban Florin",
    Id: 18,
  },
  {
    Code: "AZN",
    Name: "Azerbaijanian Manat",
    Id: 142,
  },
  {
    Code: "BAM",
    Name: "Convertible Mark",
    Id: 71,
  },
  {
    Code: "BBD",
    Name: "Barbados Dollar",
    Id: 78,
  },
  {
    Code: "BDT",
    Name: "Taka",
    Id: 35,
  },
  {
    Code: "BGN",
    Name: "Bulgarian Lev",
    Id: 17,
  },
  {
    Code: "BHD",
    Name: "Bahraini Dinar",
    Id: 8,
  },
  {
    Code: "BIF",
    Name: "Burundi Franc",
    Id: 13,
  },
  {
    Code: "BMD",
    Name: "Bermudian Dollar",
    Id: 126,
  },
  {
    Code: "BND",
    Name: "Brunei Dollar",
    Id: 153,
  },
  {
    Code: "BOB",
    Name: "Boliviano",
    Id: 46,
  },
  {
    Code: "BOV",
    Name: "Mvdol",
    Id: 3,
  },
  {
    Code: "BRL",
    Name: "Brazilian Real",
    Id: 84,
  },
  {
    Code: "BSD",
    Name: "Bahamian Dollar",
    Id: 143,
  },
  {
    Code: "BTN",
    Name: "Ngultrum",
    Id: 140,
  },
  {
    Code: "BWP",
    Name: "Pula",
    Id: 103,
  },
  {
    Code: "BYR",
    Name: "Belarussian Ruble",
    Id: 86,
  },
  {
    Code: "BZD",
    Name: "Belize Dollar",
    Id: 175,
  },
  {
    Code: "CAD",
    Name: "Canadian Dollar",
    Id: 165,
  },
  {
    Code: "CDF",
    Name: "Congolese Franc",
    Id: 31,
  },
  {
    Code: "CHE",
    Name: "WIR Euro",
    Id: 91,
  },
  {
    Code: "CHF",
    Name: "Swiss Franc",
    Id: 89,
  },
  {
    Code: "CHW",
    Name: "WIR Franc",
    Id: 173,
  },
  {
    Code: "CLF",
    Name: "Unidad de Fomento",
    Id: 47,
  },
  {
    Code: "CLP",
    Name: "Chilean Peso",
    Id: 97,
  },
  {
    Code: "CNY",
    Name: "Yuan Renminbi",
    Id: 58,
  },
  {
    Code: "COP",
    Name: "Colombian Peso",
    Id: 26,
  },
  {
    Code: "COU",
    Name: "Unidad de Valor Real",
    Id: 115,
  },
  {
    Code: "CRC",
    Name: "Costa Rican Colon",
    Id: 68,
  },
  {
    Code: "CUC",
    Name: "Peso Convertible",
    Id: 94,
  },
  {
    Code: "CUP",
    Name: "Cuban Peso",
    Id: 14,
  },
  {
    Code: "CVE",
    Name: "Cape Verde Escudo",
    Id: 162,
  },
  {
    Code: "CZK",
    Name: "Czech Koruna",
    Id: 75,
  },
  {
    Code: "DJF",
    Name: "Djibouti Franc",
    Id: 12,
  },
  {
    Code: "DOP",
    Name: "Dominican Peso",
    Id: 145,
  },
  {
    Code: "DZD",
    Name: "Algerian Dinar",
    Id: 76,
  },
  {
    Code: "EGP",
    Name: "Egyptian Pound",
    Id: 169,
  },
  {
    Code: "ERN",
    Name: "Nakfa",
    Id: 81,
  },
  {
    Code: "ETB",
    Name: "Ethiopian Birr",
    Id: 11,
  },
  {
    Code: "FJD",
    Name: "Fiji Dollar",
    Id: 34,
  },
  {
    Code: "FKP",
    Name: "Falkland Islands Pou",
    Id: 77,
  },
  {
    Code: "GBP",
    Name: "Pound Sterling",
    Id: 56,
  },
  {
    Code: "GEL",
    Name: "Lari",
    Id: 154,
  },
  {
    Code: "GHS",
    Name: "Ghana Cedi",
    Id: 54,
  },
  {
    Code: "GIP",
    Name: "Gibraltar Pound",
    Id: 15,
  },
  {
    Code: "GMD",
    Name: "Dalasi",
    Id: 30,
  },
  {
    Code: "GNF",
    Name: "Guinea Franc",
    Id: 45,
  },
  {
    Code: "GTQ",
    Name: "Quetzal",
    Id: 59,
  },
  {
    Code: "GYD",
    Name: "Guyana Dollar",
    Id: 73,
  },
  {
    Code: "HKD",
    Name: "Hong Kong Dollar",
    Id: 163,
  },
  {
    Code: "HNL",
    Name: "Lempira",
    Id: 48,
  },
  {
    Code: "HRK",
    Name: "Croatian Kuna",
    Id: 117,
  },
  {
    Code: "HTG",
    Name: "Gourde",
    Id: 92,
  },
  {
    Code: "HUF",
    Name: "Forint",
    Id: 72,
  },
  {
    Code: "IDR",
    Name: "Rupiah",
    Id: 39,
  },
  {
    Code: "ILS",
    Name: "New Israeli Sheqel",
    Id: 32,
  },
  {
    Code: "INR",
    Name: "Indian Rupee",
    Id: 161,
  },
  {
    Code: "IQD",
    Name: "Iraqi Dinar",
    Id: 43,
  },
  {
    Code: "IRR",
    Name: "Iranian Rial",
    Id: 171,
  },
  {
    Code: "ISK",
    Name: "Iceland Krona",
    Id: 41,
  },
  {
    Code: "JMD",
    Name: "Jamaican Dollar",
    Id: 119,
  },
  {
    Code: "JOD",
    Name: "Jordanian Dinar",
    Id: 61,
  },
  {
    Code: "JPY",
    Name: "Yen",
    Id: 167,
  },
  {
    Code: "KES",
    Name: "Kenyan Shilling",
    Id: 87,
  },
  {
    Code: "KGS",
    Name: "Som",
    Id: 51,
  },
  {
    Code: "KHR",
    Name: "Riel",
    Id: 120,
  },
  {
    Code: "KMF",
    Name: "Comoro Franc",
    Id: 132,
  },
  {
    Code: "KPW",
    Name: "North Korean Won",
    Id: 104,
  },
  {
    Code: "KRW",
    Name: "Won",
    Id: 65,
  },
  {
    Code: "KWD",
    Name: "Kuwaiti Dinar",
    Id: 64,
  },
  {
    Code: "KYD",
    Name: "Cayman Islands Dolla",
    Id: 19,
  },
  {
    Code: "KZT",
    Name: "Tenge",
    Id: 127,
  },
  {
    Code: "LAK",
    Name: "Kip",
    Id: 36,
  },
  {
    Code: "LBP",
    Name: "Lebanese Pound",
    Id: 95,
  },
  {
    Code: "LKR",
    Name: "Sri Lanka Rupee",
    Id: 106,
  },
  {
    Code: "LRD",
    Name: "Liberian Dollar",
    Id: 150,
  },
  {
    Code: "LSL",
    Name: "Loti",
    Id: 172,
  },
  {
    Code: "LTL",
    Name: "Lithuanian Litas",
    Id: 10,
  },
  {
    Code: "LYD",
    Name: "Libyan Dinar",
    Id: 82,
  },
  {
    Code: "MAD",
    Name: "Moroccan Dirham",
    Id: 27,
  },
  {
    Code: "MDL",
    Name: "Moldovan Leu",
    Id: 83,
  },
  {
    Code: "MGA",
    Name: "Malagasy Ariary",
    Id: 37,
  },
  {
    Code: "MKD",
    Name: "Denar",
    Id: 9,
  },
  {
    Code: "MMK",
    Name: "Kyat",
    Id: 16,
  },
  {
    Code: "MNT",
    Name: "Tugrik",
    Id: 40,
  },
  {
    Code: "MOP",
    Name: "Pataca",
    Id: 128,
  },
  {
    Code: "MRO",
    Name: "Ouguiya",
    Id: 168,
  },
  {
    Code: "MUR",
    Name: "Mauritius Rupee",
    Id: 62,
  },
  {
    Code: "MVR",
    Name: "Rufiyaa",
    Id: 42,
  },
  {
    Code: "MWK",
    Name: "Kwacha",
    Id: 55,
  },
  {
    Code: "MXN",
    Name: "Mexican Peso",
    Id: 129,
  },
  {
    Code: "MXV",
    Name: "Mexican Unidad de In",
    Id: 79,
  },
  {
    Code: "MYR",
    Name: "Malaysian Ringgit",
    Id: 113,
  },
  {
    Code: "MZN",
    Name: "Mozambique Metical",
    Id: 133,
  },
  {
    Code: "NAD",
    Name: "Namibia Dollar",
    Id: 90,
  },
  {
    Code: "NGN",
    Name: "Naira",
    Id: 177,
  },
  {
    Code: "NIO",
    Name: "Cordoba Oro",
    Id: 44,
  },
  {
    Code: "NPR",
    Name: "Nepalese Rupee",
    Id: 50,
  },
  {
    Code: "NZD",
    Name: "New Zealand Dollar",
    Id: 170,
  },
  {
    Code: "OMR",
    Name: "Rial Omani",
    Id: 33,
  },
  {
    Code: "PAB",
    Name: "Balboa",
    Id: 1,
  },
  {
    Code: "PEN",
    Name: "Nuevo Sol",
    Id: 125,
  },
  {
    Code: "PGK",
    Name: "Kina",
    Id: 121,
  },
  {
    Code: "PHP",
    Name: "Philippine Peso",
    Id: 74,
  },
  {
    Code: "PKR",
    Name: "Pakistan Rupee",
    Id: 28,
  },
  {
    Code: "PLN",
    Name: "Zloty",
    Id: 66,
  },
  {
    Code: "PYG",
    Name: "Guarani",
    Id: 178,
  },
  {
    Code: "QAR",
    Name: "Qatari Rial",
    Id: 96,
  },
  {
    Code: "RON",
    Name: "New Romanian Leu",
    Id: 98,
  },
  {
    Code: "RSD",
    Name: "Serbian Dinar",
    Id: 159,
  },
  {
    Code: "RUB",
    Name: "Russian Ruble",
    Id: 38,
  },
  {
    Code: "RWF",
    Name: "Rwanda Franc",
    Id: 123,
  },
  {
    Code: "SAR",
    Name: "Saudi Riyal",
    Id: 137,
  },
  {
    Code: "SBD",
    Name: "Solomon Islands Doll",
    Id: 80,
  },
  {
    Code: "SCR",
    Name: "Seychelles Rupee",
    Id: 141,
  },
  {
    Code: "SDG",
    Name: "Sudanese Pound",
    Id: 131,
  },
  {
    Code: "SGD",
    Name: "Singapore Dollar",
    Id: 2,
  },
  {
    Code: "SHP",
    Name: "Saint Helena Pound",
    Id: 7,
  },
  {
    Code: "SLL",
    Name: "Leone",
    Id: 88,
  },
  {
    Code: "SOS",
    Name: "Somali Shilling",
    Id: 151,
  },
  {
    Code: "SRD",
    Name: "Surinam Dollar",
    Id: 85,
  },
  {
    Code: "SSP",
    Name: "South Sudanese Pound",
    Id: 99,
  },
  {
    Code: "STD",
    Name: "Dobra",
    Id: 147,
  },
  {
    Code: "SVC",
    Name: "El Salvador Colon",
    Id: 157,
  },
  {
    Code: "SYP",
    Name: "Syrian Pound",
    Id: 22,
  },
  {
    Code: "SZL",
    Name: "Lilangeni",
    Id: 24,
  },
  {
    Code: "THB",
    Name: "Baht",
    Id: 102,
  },
  {
    Code: "TJS",
    Name: "Somoni",
    Id: 49,
  },
  {
    Code: "TMT",
    Name: "Turkmenistan New Man",
    Id: 156,
  },
  {
    Code: "TND",
    Name: "Tunisian Dinar",
    Id: 134,
  },
  {
    Code: "TOP",
    Name: "Pa'anga",
    Id: 100,
  },
  {
    Code: "TRY",
    Name: "Turkish Lira",
    Id: 155,
  },
  {
    Code: "TTD",
    Name: "Trinidad and Tobago ",
    Id: 130,
  },
  {
    Code: "TWD",
    Name: "New Taiwan Dollar",
    Id: 160,
  },
  {
    Code: "TZS",
    Name: "Tanzanian Shilling",
    Id: 152,
  },
  {
    Code: "UAH",
    Name: "Hryvnia",
    Id: 138,
  },
  {
    Code: "UGX",
    Name: "Uganda Shilling",
    Id: 114,
  },
  {
    Code: "USD",
    Name: "US Dollar",
    Id: 149,
  },
  {
    Code: "USN",
    Name: "US Dollar (Next day)",
    Id: 53,
  },
  {
    Code: "UYI",
    Name: "Uruguay Peso en Unid",
    Id: 139,
  },
  {
    Code: "UYU",
    Name: "Peso Uruguayo",
    Id: 166,
  },
  {
    Code: "UZS",
    Name: "Uzbekistan Sum",
    Id: 69,
  },
  {
    Code: "VEF",
    Name: "Bolivar",
    Id: 148,
  },
  {
    Code: "VND",
    Name: "Dong",
    Id: 63,
  },
  {
    Code: "VUV",
    Name: "Vatu",
    Id: 118,
  },
  {
    Code: "WST",
    Name: "Tala",
    Id: 29,
  },
  {
    Code: "XAF",
    Name: "CFA Franc BEAC",
    Id: 111,
  },
  {
    Code: "XAG",
    Name: "Silver",
    Id: 70,
  },
  {
    Code: "XAU",
    Name: "Gold",
    Id: 146,
  },
  {
    Code: "XBA",
    Name: "Bond Markets Unit Eu",
    Id: 23,
  },
  {
    Code: "XBB",
    Name: "Bond Markets Unit Eu",
    Id: 135,
  },
  {
    Code: "XBC",
    Name: "Bond Markets Unit Eu",
    Id: 107,
  },
  {
    Code: "XBD",
    Name: "Bond Markets Unit Eu",
    Id: 179,
  },
  {
    Code: "XCD",
    Name: "East Caribbean Dolla",
    Id: 164,
  },
  {
    Code: "XDR",
    Name: "SDR (Special Drawing",
    Id: 4,
  },
  {
    Code: "XOF",
    Name: "CFA Franc BCEAO",
    Id: 109,
  },
  {
    Code: "XPD",
    Name: "Palladium",
    Id: 136,
  },
  {
    Code: "XPF",
    Name: "CFP Franc",
    Id: 122,
  },
  {
    Code: "XPT",
    Name: "Platinum",
    Id: 112,
  },
  {
    Code: "XSU",
    Name: "Sucre",
    Id: 124,
  },
  {
    Code: "XTS",
    Name: "Codes specifically r",
    Id: 158,
  },
  {
    Code: "XUA",
    Name: "ADB Unit of Account",
    Id: 60,
  },
  {
    Code: "XXX",
    Name: "The codes assigned f",
    Id: 5,
  },
  {
    Code: "YER",
    Name: "Yemeni Rial",
    Id: 174,
  },
  {
    Code: "ZAR",
    Name: "Rand",
    Id: 105,
  },
  {
    Code: "ZMW",
    Name: "Zambian Kwacha",
    Id: 93,
  },
  {
    Code: "ZWL",
    Name: "Zimbabwe Dollar",
    Id: 110,
  },
];
